/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import {
    hooks as commonHooks,
    types as commonTypes,
    utils as commonUtils,
} from '@sitebuilder/common';

import { getStyleSchemaProperties, getLayoutSchemaProperties } from '../utils';
import ImageStyles from './Image.styles';
interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    isLink: boolean;
    fileName: string;
    fileType: string;
    imageLink: string;
    altText: string;
    functionToTransform?: string;
    isTransformData?: boolean;
    typographyClass?: string;
}

const Image = (props: commonTypes.WidgetInstanceProps) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, isLink, imageLink, fileName, fileType, altText, ...rest } =
        widgetProperties || props;

    const i18n = commonHooks.useLocalization();
    const data: any = props.data;
    const imageLinkHtml = i18n.format(imageLink || '', data);

    let isRender = {
        image: true,
    };

    const transformFunctionName = `${props.widgetInstanceId}-transform`;

    try {
        // eslint-disable-next-line no-new-func
        const transformedData =
            rest.isTransformData &&
            commonUtils.transformDataWithGlobals(
                transformFunctionName,
                rest.functionToTransform,
                data
            );

        if (transformedData) {
            isRender = { ...isRender, ...transformedData };
        }
    } catch (e) {
        console.log(e);
    }

    return isRender.image ? (
        <img
            css={css`
                ${ImageStyles}${getStyleSchemaProperties(
                    widgetProperties
                )}${getLayoutSchemaProperties(widgetProperties)}${styles || ''}
            `}
            className={`image ${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
            src={isLink ? imageLinkHtml : `/images/${fileName}.${fileType}`}
            alt={i18n.format(altText || '', data) || 'image'}
        />
    ) : (
        <></>
    );
};

export default Image;
